import { useState, useEffect } from 'react'
import { horaLocal, horaUtc } from 'src/utils/fechas'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

/*
  El reloj era la causa principal del CLS de la home (0,81 de 0,85 medido con
  Lighthouse en movil). Se montaba con dynamic(ssr:false), asi que el HTML
  estatico salia sin el: la AppBar nacia con menos altura y, al hidratar,
  aparecian las dos lineas de hora y empujaban hacia abajo el contenedor de
  contenido entero (8.238 px de alto).

  Ahora renderiza en servidor y cliente exactamente el mismo marcado —el
  placeholder '--:--:--' mide igual que 'HH:mm:ss'— y la hora real solo entra
  despues de montar. Cero desajuste de hidratacion y cero reflow.

  El valor va con tabular-nums y ancho fijo para que cambiar de 1 a 8 tampoco
  mueva nada mientras corre el segundero.
*/

const PLACEHOLDER = '--:--:--'

const leer = tipo => (tipo === 'local' ? horaLocal() : horaUtc())

function Clock({ type }) {
  const [date, setDate] = useState(PLACEHOLDER)

  useEffect(() => {
    setDate(leer(type))
    const timerId = setInterval(() => setDate(leer(type)), 1000)

    return () => clearInterval(timerId)
  }, [type])

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', padding: '0.2em' }}
    >
      <Typography color='secondary' variant='caption' sx={{ mr: 1 }}>
        {type ? 'L' : 'S'}T:
      </Typography>
      <Typography
        color='primary'
        variant='caption'
        align='center'
        sx={{ fontVariantNumeric: 'tabular-nums', minWidth: '4.5em', display: 'inline-block' }}
      >
        {date}
      </Typography>
    </Box>
  )
}

export default Clock
